var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserCircleBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "account_circle_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_488",
    "data-name": "Path 488",
    d: "M0,0H46V46H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_489",
    "data-name": "Path 489",
    d: "M23,2A21,21,0,1,0,44,23,21.008,21.008,0,0,0,23,2ZM12.647,36.188c.9-1.89,6.4-3.738,10.353-3.738s9.471,1.848,10.353,3.738a16.643,16.643,0,0,1-20.706,0Zm23.709-3.045c-3-3.654-10.29-4.893-13.356-4.893S12.647,29.489,9.644,33.143a16.8,16.8,0,1,1,26.712,0ZM23,10.4a7.35,7.35,0,1,0,7.35,7.35A7.331,7.331,0,0,0,23,10.4Zm0,10.5a3.15,3.15,0,1,1,3.15-3.15A3.146,3.146,0,0,1,23,20.9Z",
    transform: "translate(0 0)",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircleBlack);
export default __webpack_public_path__ + "static/media/User_circle_black.a5cff98377962ef4b868739e6a6b97b8.svg";
export { ForwardRef as ReactComponent };